export default {
  FEEDBACK_STATS_TITLE: 'Feedback',
  FEEDBACK_STATS_VIEW_REWARDS_LINK: 'View Rewards',
  FEEDBACK_STATS_EXPORT_CSV_LINK: 'Export CSV',
};
